import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const ScrollToTopModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "scroll-to-top" */
            './'
        )
    ),
    componentName: 'ScrollToTop',
});

export default ScrollToTopModule;
